var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCursor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 19,
    fill: "#7752BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8861 27.5982L21.7432 18.4554C21.6361 18.3393 21.4932 18.2857 21.3414 18.2857C21.27 18.2857 21.1897 18.3036 21.1272 18.3304C20.9129 18.4196 20.77 18.625 20.77 18.8571V32.2857C20.77 32.5179 20.9129 32.7232 21.1272 32.8125C21.1897 32.8393 21.27 32.8571 21.3414 32.8571C21.4932 32.8571 21.6361 32.7946 21.7432 32.6875L24.5289 29.9018L26.2343 33.9375C26.3593 34.2232 26.6897 34.3661 26.9843 34.2411L28.5647 33.5714C28.8504 33.4464 28.9932 33.1161 28.8682 32.8214L27.0736 28.5714H30.4843C30.7164 28.5714 30.9218 28.4286 31.0111 28.2143C31.1004 28.0089 31.0557 27.7589 30.8861 27.5982Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.e2b37627902217868acb2e62a8bdcd2f.svg";
export { ForwardRef as ReactComponent };